'use strict';
var DisplayType;
(function (DisplayType) {
    DisplayType["Inline"] = "inline";
    DisplayType["Drawer"] = "drawer";
    DisplayType["Layover"] = "layover";
})(DisplayType || (DisplayType = {}));
export default DisplayType;
